import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { Typography } from 'antd';

function EChart(props) {
  const { Title } = Typography;

  let data = props.data;

  let cost_utility               = new Map();
  let cost_marketing             = new Map();
  let cost_authentication        = new Map();
  let cost_service               = new Map();
  let cost_unknown               = new Map();

  let total_cost                 = new Map();

  let revenue_utility            = new Map();
  let revenue_marketing          = new Map();
  let revenue_authentication     = new Map();
  let revenue_service            = new Map();
  let revenue_unknown            = new Map();

  let total_revenue              = new Map();


  for(let i =0; i<data.length; i++){
    const year = data[i].date_sent.split("T")[0].split("-")[0];
    const month = data[i].date_sent.split("T")[0].split("-")[1];

    total_cost.set(year + "-" + month, (total_cost.get(year + "-" + month) || 0) + data[i].company_cost);
    total_revenue.set(year + "-" + month, (total_revenue.get(year + "-" + month) || 0) + data[i].customer_cost);

    switch (data.at(i).message_type){
      case "Marketing":
        cost_marketing.set(year + "-" + month, (cost_marketing.get(year + "-" + month) || 0) + data[i].company_cost);
        revenue_marketing.set(year + "-" + month, (revenue_marketing.get(year + "-" + month) || 0) + data[i].customer_cost);
        break;
      case "Authentication":
        cost_authentication.set(year + "-" + month, (cost_authentication.get(year + "-" + month) || 0) + data[i].company_cost);
        revenue_authentication.set(year + "-" + month, (revenue_authentication.get(year + "-" + month) || 0) + data[i].customer_cost);
        break;
      case "Service":
        cost_service.set(year + "-" + month, (cost_service.get(year + "-" + month) || 0) + data[i].company_cost);
        revenue_service.set(year + "-" + month, (revenue_service.get(year + "-" + month) || 0) + data[i].customer_cost);
        break;
      case "Utility":
        cost_utility.set(year + "-" + month, (cost_utility.get(year + "-" + month) || 0) + data[i].company_cost);
        revenue_utility.set(year + "-" + month, (revenue_utility.get(year + "-" + month) || 0) + data[i].customer_cost);
        break;
      default:
        cost_unknown.set(year + "-" + month, (cost_unknown.get(year + "-" + month) || 0) + data[i].company_cost);
        revenue_unknown.set(year + "-" + month, (revenue_unknown.get(year + "-" + month) || 0) + data[i].customer_cost);
        break;
      }
  }

  // Sorting total cost and total revenue maps
  total_cost = new Map([...total_cost.entries()].sort());
  total_revenue = new Map([...total_revenue.entries()].sort());

  // Sorting cost maps
  cost_utility = new Map([...cost_utility.entries()].sort());
  cost_marketing = new Map([...cost_marketing.entries()].sort());
  cost_authentication = new Map([...cost_authentication.entries()].sort());
  cost_service = new Map([...cost_service.entries()].sort());
  cost_unknown = new Map([...cost_unknown.entries()].sort());

  // Sorting revenue maps
  revenue_utility = new Map([...revenue_utility.entries()].sort());
  revenue_marketing = new Map([...revenue_marketing.entries()].sort());
  revenue_authentication = new Map([...revenue_authentication.entries()].sort());
  revenue_service = new Map([...revenue_service.entries()].sort());
  revenue_unknown = new Map([...revenue_unknown.entries()].sort());


  // Creating arrays for yAxis
  const yAxis_total_cost = Array.from(total_cost.values()).map((value) =>
    parseFloat(value.toFixed(3))
  );

  const yAxis_total_revenue = Array.from(total_revenue.values()).map((value) =>
    parseFloat(value.toFixed(3))
  );

  const yAxis_cost_utility = Array.from(cost_utility.values()).map((value) =>
    parseFloat(value.toFixed(3))
  );

  const yAxis_cost_marketing = Array.from(cost_marketing.values()).map((value) =>
    parseFloat(value.toFixed(3))
  );

  const yAxis_cost_authentication = Array.from(cost_authentication.values()).map((value) =>
    parseFloat(value.toFixed(3))
  );

  const yAxis_cost_service = Array.from(cost_service.values()).map((value) =>
    parseFloat(value.toFixed(3))
  );

  const yAxis_cost_unknown = Array.from(cost_unknown.values()).map((value) =>
    parseFloat(value.toFixed(3))
  );

  const yAxis_revenue_utility = Array.from(revenue_utility.values()).map((value) =>
    parseFloat(value.toFixed(3))
  );

  const yAxis_revenue_marketing = Array.from(revenue_marketing.values()).map((value) =>
    parseFloat(value.toFixed(3))
  );

  const yAxis_revenue_authentication = Array.from(revenue_authentication.values()).map((value) =>
    parseFloat(value.toFixed(3))
  );

  const yAxis_revenue_service = Array.from(revenue_service.values()).map((value) =>
    parseFloat(value.toFixed(3))
  );

  const yAxis_revenue_unknown = Array.from(revenue_unknown.values()).map((value) =>
    parseFloat(value.toFixed(3))
  );

  const xAxis = Array.from(total_cost.keys());
  // let e = 0;
  // for(let i=0; i<xAxis.length; i++){
  //   if(xAxis.at(i + e) != Array.from(unique_users.keys()).at(i)){
  //     yAxis_users.splice(i, 0, 0);
  //     e++;
  //   }
  // }

  
  const seriesDataBar = [
    {
      name: 'Cost (Utility)',
      type: 'bar',
      data: yAxis_cost_utility,
      color: '#e27c7c',
    },
    {
      name: 'Cost (Marketing)',
      type: 'bar',
      data: yAxis_cost_marketing,
      color: '#cb6f6f',
    },
    {
      name: 'Cost (Authentication)',
      type: 'bar',
      data: yAxis_cost_authentication,
      color: '#b46363',
    },
    {
      name: 'Cost (Service)',
      type: 'bar',
      data: yAxis_cost_service,
      color: '#9e5656',
    },
    {
      name: 'Cost (Unknown Type)',
      type: 'bar',
      data: yAxis_cost_unknown,
      color: '#874a4a',
    },
    {
      name: 'Revenue (Utility)',
      type: 'bar',
      data: yAxis_revenue_utility,
      color: '#6cd4c5',
    },
    {
      name: 'Revenue (Marketing)',
      type: 'bar',
      data: yAxis_revenue_marketing,
      color: '#61beb1',
    },
    {
      name: 'Revenue (Authentication)',
      type: 'bar',
      data: yAxis_revenue_authentication,
      color: '#56a99d',
    },
    {
      name: 'Revenue (Service)',
      type: 'bar',
      data: yAxis_revenue_service,
      color: '#4b9489',
    },
    {
      name: 'Revenue (Unkown Type)',
      type: 'bar',
      data: yAxis_revenue_unknown,
      color: '#407f76',
    },
  ];

  const lineChartAnnotationsRevenue = yAxis_total_revenue.map((value, index) => ({
    x: xAxis[index], // Assuming xAxis contains corresponding categories
    y: value,
    label: {
      borderColor: '#203f3b',
      style: {
        color: '#FFFFFF',
        background: '#203f3b',
        fontSize: '12px'
      },
      text: "Total: " + value, // Adjust the label text as needed
    },
  }));

  const lineChartAnnotationsCost = yAxis_total_cost.map((value, index) => ({
    x: xAxis[index], // Assuming xAxis contains corresponding categories
    y: value - 5,
    label: {
      borderColor: '#432525',
      style: {
        color: '#FFFFFF',
        background: '#432525',
        fontSize: '12px'
      },
      text: "Total: " + value, // Adjust the label text as needed
    },
  }));

  const chartOptions = {
    chart: {
      type: 'bar',
      stacked: true,
      toolbar: {
        show: true, // Display the zoom-in/out buttons
      },
      zoom: {
        enabled: true
      },
    },
    xaxis: {
      categories: xAxis,
      tickPlacement: 'on',
      labels: {
        style: {
          colors: '#000000', // X-axis label color
        },
      },
      axisBorder: {
        show: true,
        color: '#000000', // X-axis border color
      },
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return parseFloat(value).toFixed(2);
        },
        style: {
          colors: '#000000', // X-axis label color
        },
      },
      axisBorder: {
        show: true,
        color: '#000000', // X-axis border color
      },
      min: -60,
      median: 0,
      max: 60,
      tickAmount: 5,
    },
    title: {
      text: 'Cost & Revenue',
      align: 'left',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontWeight: 'bold',
        color: '#000000',
        fontSize: '20px', // Adjust the font size as needed
        fontFamily: 'Helvetica, Arial, sans-serif', // Set to Helvetica and fallback to Arial and generic sans-serif
      },
    },
    stroke: {
      width: 1, // Adjust the line width
    },
    dataLabels: {
      enabled: false,
      formatter: function (val, opts) {
        return val;
      },
    },
    annotations: {
      yaxis: [
        {
          y: 0, // Set the median value here
          borderColor: '#FFFFFF', // Color of the line
          label: {
            borderColor: '#FFFFFF',
            style: {
              color: '#FFFFFF',
              background: '#FFFFFF',
            },
          },
        },
      ],
      // Add annotations for line chart
      points: [...lineChartAnnotationsRevenue, ...lineChartAnnotationsCost],
    },
    legend: {
      show: false, // Hide the legend
    },

  };
  
  

  return (
    <>
      <div id="chart">
        <ReactApexChart
          className="chart"
          options={chartOptions}
          series={seriesDataBar}
          type="bar"
          height={835}
        />
      </div>
    </>
  );
}

export default EChart;